module.exports = __webpack_public_path__ + "static/_DSC0319-min-e58433d3e5246c9f98efe096942aa5fd.jpg";